import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectors, actions } from '../store/dux/fields-dux';
import { useUrlUpdater } from './use-url-updater';

export function useFields() {
  const { updateParams } = useUrlUpdater();
  const dispatch = useDispatch();
  const isLoading = useSelector(selectors.isLoading);
  const hasAutoSelected = useSelector(selectors.hasAutoSelectedField);
  const fields = useSelector(selectors.growerFields);
  const focusedBounds = useSelector(selectors.focusedBounds);
  const focusedAaid = useSelector(selectors.focusedAaid);
  const growerBounds = useSelector(selectors.growerBounds);
  const selectedAaids = useSelector(selectors.selectedAaids);
  const selectedBounds = useSelector(selectors.selectedBounds);
  const selectedFields = useSelector(selectors.selectedFields);

  const selectFields = useCallback(
    (aaids) => {
      updateParams({ aaid: aaids.length === 1 ? aaids[0] : '' });
      dispatch(
        actions.setSelectedGrowerFields(
          fields.filter((f) => aaids.includes(f.aaManagedId)),
        ),
      );
    },
    [dispatch, fields, updateParams],
  );

  const autoSelectField = useCallback(
    (aaid) => {
      if (hasAutoSelected) return;
      dispatch(actions.setAutoSelected());
      selectFields([aaid]);
    },
    [dispatch, hasAutoSelected, selectFields],
  );

  const focusAaid = useCallback(
    (aaid) => dispatch(actions.focusAaid(aaid)),
    [dispatch],
  );

  return {
    isLoading,
    allFields: fields,
    bounds: focusedBounds || selectedBounds || growerBounds,
    focusAaid,
    focusedAaid,
    selectFields,
    selectedAaids,
    selectedFields,
    autoSelectField,
  };
}
